import { Injectable } from "@angular/core";
import {
  ActivatedRouteSnapshot,
  Router,
  RouterStateSnapshot,
} from "@angular/router";
import { AuthenticationService } from "../services/authentication.service";

@Injectable({ providedIn: "root" })
export class SuperAdminGuard {
  constructor(
    private router: Router,
    private authService: AuthenticationService,
  ) {}

  canActivate(
    _route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): boolean {
    const currentUser = this.authService.currentUserValue;
    const hasRole =
      currentUser?.roles?.some((role) => role.name === "SuperAdmin") === true;

    if (hasRole && currentUser.allOwners === true) {
      return true;
    }

    this.router.navigate(["/error-401"], {
      queryParams: { returnUrl: state.url },
    });
    return false;
  }
}
